<template>
  <v-row>
    <v-col cols="12">
      <v-card class="progress-status-card mb-2" elevation="1" rounded="xl">
        <v-card-text class="px-6 pb-6">
          <div class="progress-section mb-6">
            <div class="d-flex justify-space-between align-center mb-3">
              <span class="text-body-1 font-weight-medium text-grey-darken-2">
                Status de Preenchimento de itens obrigatórios
              </span>
              <v-chip
                :color="completedPercentage === 100 ? 'success' : 'primary'"
                size="small"
                variant="elevated"
              >
                {{ Math.ceil(completedPercentage) }}%
              </v-chip>
            </div>

            <v-progress-linear
              :value="completedPercentage"
              :color="completedPercentage === 100 ? 'success' : 'primary'"
              bg-color="grey-lighten-4"
              height="16"
              rounded
              class="progress-bar-enhanced"
            >
            </v-progress-linear>
          </div>

          <div class="items-grid pr-2">
            <div v-for="item in expectedItems" :key="item.value" class="item-row mb-3">
              <v-card
                :color="isFilled(item.value) ? 'success' : 'grey-lighten-5'"
                :variant="isFilled(item.value) ? 'tonal' : 'flat'"
                class="item-card pa-4"
                rounded="lg"
                :ripple="false"
              >
                <div class="d-flex align-center">
                  <v-avatar
                    :color="isFilled(item.value) ? 'green' : 'grey-lighten-3'"
                    size="22"
                    class="mr-4"
                  >
                    <v-icon :color="isFilled(item.value) ? 'white' : 'grey-darken-1'" size="18">
                      {{ isFilled(item.value) ? "mdi-check" : "mdi-circle-outline" }}
                    </v-icon>
                  </v-avatar>

                  <div class="flex-grow-1">
                    <div class="text-body-1 font-weight-medium mb-1">
                      {{ item.label }}
                    </div>
                    <div
                      class="text-caption d-flex align-center"
                      :class="isFilled(item.value) ? 'text-success' : 'text-grey-darken-1'"
                    >
                      {{ isFilled(item.value) ? "Preenchido" : "Falta preencher" }}
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "EProgressoPreenchimento",
  props: {
    expectedItems: {
      type: Array,
      required: true, // [{ label: 'Data da Aula', value: 'dataFormatada' }, ...]
    },
    filledItems: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    completedPercentage() {
      const isTotalFilled = this.expectedItems.filter((item) => this.isFilled(item.value)).length;
      const total = this.expectedItems.length || 1;
      return (isTotalFilled / total) * 100;
    },
    isTotalFilled() {
      return this.expectedItems.every((item) => this.isFilled(item.value));
    },
  },
  watch: {
    isTotalFilled: {
      handler(newValue) {
        this.$emit("total-filled-changed", newValue);
      },
      immediate: true,
    },
  },
  methods: {
    isFilled(item) {
      return this.filledItems.includes(item);
    },
  },
};
</script>
<style scoped>
.progress-status-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.progress-bar-enhanced {
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 12px !important;
}
.items-grid {
  max-height: 200px;
  overflow-y: auto;
}
.item-card {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(10px);
}
.item-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.item-row {
  animation: fadeInUp 0.3s ease-out forwards;
}
.item-row:nth-child(1) {
  animation-delay: 0.1s;
}
.item-row:nth-child(2) {
  animation-delay: 0.2s;
}
.item-row:nth-child(3) {
  animation-delay: 0.3s;
}
.item-row:nth-child(4) {
  animation-delay: 0.4s;
}
.item-row:nth-child(5) {
  animation-delay: 0.5s;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.progress-section {
  position: relative;
}
.progress-section::before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1), rgba(76, 175, 80, 0.1));
  border-radius: 16px;
  z-index: -1;
  opacity: 0.3;
}
.summary-section {
  position: relative;
}
@media (max-width: 600px) {
  .progress-status-card {
    margin: 8px;
  }
  .item-card {
    margin-bottom: 12px;
  }
}
</style>
